module.exports = __webpack_public_path__ + "img/item-bg.070a4be0.png";